import { render } from "./add_new_category.vue?vue&type=template&id=fcf9a1bc"
import script from "./add_new_category.vue?vue&type=script&lang=js"
export * from "./add_new_category.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__